"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;

var _reactIntl = require("react-intl");

var messages = (0, _reactIntl.defineMessages)({
  backToList: {
    "id": "filter.backToList",
    "defaultMessage": "back to list"
  },
  NOT: {
    "id": "filter.NOT",
    "defaultMessage": "NOT"
  },
  OR: {
    "id": "filter.OR",
    "defaultMessage": "OR"
  },
  AND: {
    "id": "filter.AND",
    "defaultMessage": "AND"
  },
  addFilter: {
    "id": "filter.addFilter",
    "defaultMessage": "Add filter"
  },
  changeFilter: {
    "id": "filter.changeFilter",
    "defaultMessage": "Change filter"
  },
  applyFilter: {
    "id": "filter.applyFilter",
    "defaultMessage": "Apply filter"
  },
  from: {
    "id": "filter.from",
    "defaultMessage": "From"
  },
  to: {
    "id": "filter.to",
    "defaultMessage": "To"
  },
  partialMatch: {
    "id": "filter.partialMatch",
    "defaultMessage": "Partial match"
  },
  applyFilters: {
    "id": "filter.applyFilters",
    "defaultMessage": "Apply Filters"
  },
  resetFilters: {
    "id": "filter.resetFilters",
    "defaultMessage": "Reset Filters"
  },
  requiredFilter: {
    "id": "filter.requiredFilter",
    "defaultMessage": "Required filter"
  }
});
exports.messages = messages;
//# sourceMappingURL=sb-structured-filter-i18n.js.map